<template>
  <div v-if="!isLoading">

        <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <!-- Card stats -->
      <b-row>
        <b-col xl="4" md="6">
            <stats-card title="Nombre del Buque"
                        type="gradient-red"
                        :sub-title="BuquesFechas.length > 0 ? BuquesFechas[0].BUQUE_DE_DESCARGA : '-'"
                        icon="fas fa-ship"
                        class="mb-4">
            </stats-card>
          </b-col>

          <b-col xl="4" md="6">
            <stats-card title="Agente Naviero"
                        type="gradient-orange"
                        :sub-title="BuquesFechas.length > 0 ? BuquesFechas[0].AGENTE_NAVIERO : '-'"
                        icon="fas fa-anchor"
                        class="mb-4">
            </stats-card>
          </b-col>

        <b-col xl="4" md="6">
          <stats-card title="Puerto"
                      type="gradient-green"
                      :sub-title="BuquesFechas.length > 0 ? BuquesFechas[0].PUERTO : '-'"
                      icon="fas fa-industry"
                      class="mb-4">
          </stats-card>
        </b-col>
        <b-col xl="4" md="6">
          <stats-card title="Fecha de Arribo"
                      type="gradient-red"
                      :sub-title="BuquesFechas.length > 0 ? BuquesFechas[0].FECHA_ARRIBO : '-'"
                      icon="ni ni-calendar-grid-58"
                      class="mb-4">
          </stats-card>
        </b-col>
        <b-col xl="4" md="6">
          <stats-card title="Fecha de Atraque"
                      type="gradient-orange"
                      :sub-title="BuquesFechas.length > 0 ? BuquesFechas[0].FECHA_ATRAQUE : '-'"
                      icon="ni ni-calendar-grid-58"
                      class="mb-4">
          </stats-card>
        </b-col>
        <b-col xl="4" md="6">
          <stats-card title="Fecha de fin Operaciones"
                      type="gradient-green"
                      :sub-title="BuquesFechas.length > 0 ? BuquesFechas[0].FIN_DE_OPERACIONES : '-'"
                      icon="ni ni-calendar-grid-58"
                      class="mb-4">
          </stats-card>
        </b-col>
          <b-col xl="4" md="6">
            <stats-card title="Cantidad Total de Viajes"
            type="gradient-red"
            :sub-title="ContadorDeViajes.toString()"
            icon="ni ni-send"
            class="mb-4">

          </stats-card>
        </b-col>
        <b-col xl="4" md="6">
          <stats-card title="Cantidad total de Camiones"
          type="gradient-orange"
          :sub-title="Camiones.toString()"
          icon="fas fa-truck"
          class="mb-4">
 
        </stats-card>
      </b-col>
    <b-col xl="4" md="6">
      <stats-card title="Estado"
                  type="gradient-info"
                  :sub-title="BuquesFechas.length > 0 ? BuquesFechas[0].ESTATUS : '-'"
                  icon="fas fa-signal"
                  class="mb-4">
      </stats-card>
    </b-col>
  </b-row>
    </base-header>
    <!--Charts-->
      <b-row class="mt-5">
        <b-col xl="12" class="mb-5 mb-xl-0">
          <reporte-table     :listaDatosData="listaDatosData"
                             :listaDatos="listaDatos"
                             :listaDatosProducto="listaDatosProducto"
                             :listaConsignave="listaConsignave"
                             :listaClientesNave="listaClientesNave"
                             :DataCompleta="DataCompleta"
                             :listaDatosDistribucion="listaDatosDistribucion"
                             :listaDatosAlmacenDistribucion="listaDatosAlmacenDistribucion"
                             :ListaAlmacenes="ListaAlmacenes"
                             :listaJornada="listaJornada"
                             :BuquesFechas="BuquesFechas"
                             :listaSilos="listaSilos"
          ></reporte-table>
          </b-col>
      </b-row>
  </div>
  <div v-else>
    <!-- Puedes colocar un indicador de carga aquí, como un spinner o un mensaje -->
    Cargando datos...
  </div>
</template>
<script>
  // Charts
  import * as chartConfigs from '@/components/Charts/config';
import LineChart from '@/components/Charts/LineChart';
import BarChart from '@/components/Charts/BarChart';
import PieChart from '@/components/Charts/PieChart'; 
import axios from 'axios';

  // Components
  import BaseProgress from '@/components/BaseProgress';
  import StatsCard from '@/components/Cards/StatsCard';

  // Tables
  import ReporteTable from './Dashboard/ReporteTable';
  import ParalizacionesTable from './Dashboard/ParalizacionesTable';
  import PageVisitsTable from './Dashboard/PageVisitsTable';
  import AlmacenVisitsTable from './Dashboard/AlmacenVisitsTable';
  import CamionesTable from './Dashboard/CamionesTable';

  export default {
    components: {
      LineChart,
      BarChart,
      PieChart, 
      BaseProgress,
      StatsCard,
      ParalizacionesTable,
      PageVisitsTable,
      CamionesTable, 
      ReporteTable,
      AlmacenVisitsTable
    },
    data() {
      return {
        isLoading: true, // Indica si los datos están cargando
        pieChartData: {
      labels: [],
      datasets: [{
        backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
        data: [],
      }],
    },
        listaDatosData: [],
        listaDatos: [],
        listaDatosProducto: [],
        listaConsignave:[],
        listaClientesNave:[],
        listaDatosAlmacenDistribucion: [],
        listaDatosDistribucion: [],
        ListaAlmacenes:[],
        listaJornada:[],
        listaNaves: [],
        listaParalizacion: [],
        listaSilos:[]
      };
    },

    created(){
      this.cargarTodosLosDatos();

     },
     computed:{

      routeParams() {
      return this.$route.params;
    },

    // Utiliza la nueva propiedad calculada para obtener los parámetros
    ID_NAVE() {
      return this.routeParams.ID_NAVE || '';
    },

    ID_CONSIGNATARIO() {
      return this.routeParams.ID_CONSIGNATARIO || '';
    },

    BuquesFechas() {
    // Comprueba si listaNaves está definida y tiene elementos
    if (this.listaNaves && this.listaNaves.length > 0) {
      // Mapea los datos de listaNaves a la estructura deseada
      return this.listaNaves.map((item) => ({
        FECHA_ARRIBO: item.FECHA_ARRIBO,
        FECHA_ATRAQUE: item.FECHA_ATRAQUE,
        ESTATUS: item.ESTATUS,
        BUQUE_DE_DESCARGA: item.BUQUE_DE_DESCARGA,
        PUERTO: item.PUERTO,
        AGENTE_NAVIERO: item.AGENTE_NAVIERO,
        FIN_DE_OPERACIONES: item["FIN DE OPERACIONES"],
      }));
    } else {
      // Retorna un array vacío si listaNaves no está disponible o está vacía
      return [];
    }
  },


      AlmacenesDistribution() {
        return this.listaDatosAlmacenDistribucion.map((item) => {
          if (this.listaDatos && this.listaDatos.length > 0) {
            this.listaDatos.forEach(productosnave => {
              if (productosnave.ID == item.ID_PRODUCTO)
                item.PRODUCTO = productosnave.PRODUCTO
            });
          }

          if (this.ListaAlmacenes && this.ListaAlmacenes.length > 0) {
            this.ListaAlmacenes.forEach(almacen => {
              if (almacen.ID == item.ALMACEN)
                item.ALMACEN = almacen.ALMACEN
            });
          }

          return {
            CANTIDAD: this.convertir(item.CANTIDAD),
            PRODUCTO: item.PRODUCTO,
            ALMACEN: item.ALMACEN,
            ID_PRODUCTO: item.ID_PRODUCTO,
            ID: item.ID
          };
        });
      },

      AlmacenUnico() {
      let almacen = [  
         ...new Set(this.listaDatosAlmacenDistribucion.map(almacenlist => almacenlist.ID))
        ]
         return almacen
      },


      JornadaFiltrada() {
    return this.JornadaUnica.filter(idproductophite => this.ViajesBalanzaJornada(idproductophite) > 0);
  },

    JornadaUnica() {
    let jornada = [
      ...new Set(this.listaJornada.map((productlist) => productlist.ID)),
    ];
    return jornada;
  },


      ContadorDeViajes() {
        return this.DataCompleta.length
      },

      computedLineChartData() {
          const labels = [];
          const dataLine1 = [];
          const dataLine2 = [];

          this.JornadaFiltrada.forEach(row => {
            const jornadaNumber = this.Jornada(row).split('N°')[1].trim(); // Extraer solo el número de "JORNADA N° X"
            labels.push(`N° ${jornadaNumber}`);
            dataLine1.push(this.PnetoBalanzaJornada(row)); // Datos para la línea 1
            dataLine2.push(this.PnetoAlmacenEnAlmacen(row)); // Datos para la línea 2, reemplaza 'OtraFuncion' con la función correcta
          });

          return {
            labels,
            datasets: [
              {
                label: 'Balanza',
                backgroundColor: '#004D6B4D',
                borderColor: '#004D6B',
                data: dataLine1,
              },
              {
                label: 'Almacén',
                backgroundColor: '#008B8B4D',
                borderColor: '#008B8B',
                data: dataLine2,
              },
            ],
          };
        },

    


            computedBarChartData() {
          const labels = [];
          const manifestadoData = [];
          const pnetoData = [];
          const productoData = [];

          this.AlmacenUnico.forEach(row => {
            const nombreAlmacen = this.NombreAlmacen(row);
            const productoAlmacen = this.ProductoAlmacen(row);

            // Obtener iniciales del NombreAlmacen
            const initials = this.getInitials(productoAlmacen);

            // Crear etiquetas combinando iniciales, ProductoAlmacen y/o otros detalles necesarios
            labels.push(`${nombreAlmacen} - ${initials}`);

            // Agregar datos para Manifestado y PnetoBalanza
            manifestadoData.push(this.ManifestadoAlmacen(row));
            pnetoData.push(this.PnetoBalanzaEnAlmacen(row));
          });

          return {
            labels,
            datasets: [
              {
                label: 'Manifestado',
                backgroundColor: '#FFAF1D',
                data: manifestadoData,
              },
              {
                label: 'Descargado',
                backgroundColor: '#FF6800',
                data: pnetoData,
              },
            ],
          };
        },

      computedPsdaieChartData() {
    const labels = [];
    const data = [];

    this.ProductoUnico.forEach(row => {
      labels.push(this.Producto(row));
      data.push(this.PnetoBalanza(row));
    });

    return {
      labels,
      datasets: [{
        backgroundColor: ['#FFAF1D', '#FF6800', '#004D6B', '#008B8B', '#BEDBE1', '#001C26' ],
        data,
      }],
    };
  },

  manifestadoVsDescargadoPieData() {
  let totalManifestado = 0;
  let totalDescargado = 0;

  // Suma todos los valores de Manifestado y Descargado
  this.ProductoUnico.forEach(row => {
    totalManifestado += parseFloat(this.ManifestadoBalanza(row));
    totalDescargado += parseFloat(this.PnetoBalanza(row));
  });

  // Calcula la diferencia y asegura que solo tenga dos decimales
  let diferencia = totalManifestado - totalDescargado;
  let faltanteDescargar = parseFloat(diferencia.toFixed(3));

  // Prepara los datos para el gráfico de pastel
  return {
    labels: ['Descargado', 'Saldo'],
    datasets: [{
      data: [totalDescargado, faltanteDescargar], // Asegura dos decimales para la parte faltante
      backgroundColor: ['#001C26', '#BEDBE1'],
      hoverBackgroundColor: ['#001C26', '#BEDBE1']
    }]
  };
},


  computedPieChartData() {
          const labels = [];
          const manifestadoData = [];
          const pnetoData = [];
          const productoData = [];

          this.ProductoUnico.forEach(row => {
            const nombreAlmacen = this.Producto(row);
            const productoAlmacen = this.PnetoBalanza(row);

            // Obtener iniciales del NombreAlmacen
            const initials = this.getInitials(productoAlmacen);

            // Crear etiquetas combinando iniciales, ProductoAlmacen y/o otros detalles necesarios
            labels.push(`${nombreAlmacen}`);

            // Agregar datos para Manifestado y PnetoBalanza
            manifestadoData.push(this.ManifestadoBalanza(row));
            pnetoData.push(this.PnetoBalanza(row));
          });

          return {
            labels,
            datasets: [
              {
                label: 'Manifestado',
                backgroundColor: '#001C26',
                data: manifestadoData,
              },
              {
                label: 'Descargado',
                backgroundColor: '#BEDBE1',
                data: pnetoData,
              },
            ],
          };
        },



      Camiones() {
      let camiones = [  
         ...new Set(this.listaDatosData.map(listamarca => listamarca.PLACA))
        ]

        let este = camiones.filter(function(dato){
              return dato != undefined
            });
         return este.length
      },

      DataCompleta() {

        if (!this.listaDatosData || !this.listaJornada || !this.listaDatosAlmacenDistribucion ) {
      return []; // Retorna un arreglo vacío si alguna dependencia no está disponible aún
    }

    return this.listaDatosData.map(item => {
      const jornadaItem = this.listaJornada.find(j => j.ID === item.JORNADA);
      const almacenEncontrado = this.AlmacenesDistribution.find(a => a.ID === item.ID_DIST_PRODCUTO_ALM);
      const bodegaEncontrado = this.listaDatosDistribucion.find (b => b.ID === item.ID_DIST_PRODUCTOS )
     return  {
      PESO_NETO_PUERTO: this.convertir(item.PESO_NETO_PUERTO),
      PESO_BRUTO_PUERTO: this.convertir(item.PESO_BRUTO_PUERTO),
      PESO_TARA_PUERTO: this.convertir(item.PESO_TARA_PUERTO),
      PESO_BRUTO_ALMACEN: this.convertir(item.PESO_BRUTO_ALMACEN),
      PESO_NETO_ALMCEN: this.convertir(item.PESO_NETO_ALMCEN),
      PESO_TARA_ALMACEN: this.convertir(item.PESO_TARA_ALMACEN),
      DIFERENCIA_PESO_BALANZA_ALMACEN: this.convertir(item.DIFERENCIA_PESO_BALANZA_ALMACEN),
      ID_PRODUCTO: item.ID_PRODUCTO,
      TICKET: item.TICKET,
      BL: item.BL,
      DESTINE: item.ID_DIST_PRODCUTO_ALM,
      PLACA: item.PLACA,
      TRANSPORTE: item.TRANSPORTE,
      TIEMPO_ANTES_DE_CARGIO: item.TIEMPO_ANTES_DE_CARGIO,
      FECHA_INGRESO_BALANZA: item.FECHA_INGRESO_BALANZA,
      FECHA_INICIO_CARGUIO: item.FECHA_INICIO_CARGUIO,
      TIEMPO_CARGIO: item.TIEMPO_CARGIO,
      TIEMPO_FIN_CARG_SALIDA_BALANZA: item.TIEMPO_FIN_CARG_SALIDA_BALANZA,
      TIEMPO_ESTADIA_PUERTO: item.TIEMPO_ESTADIA_PUERTO,
      FECHA_FIN_CARGIO: item.FECHA_FIN_CARGIO,
      BALANZA_ENTRADA: item.BALANZA_ENTRADA,
      FECHA_SALIDA_BALANZA: item.FECHA_SALIDA_BALANZA,
      BALANZA_SALIDA: item.BALANZA_SALIDA,
      FECHA_INGRESO_ALMACEN: item.FECHA_INGRESO_ALMACEN,
      FECHA_SALIDA_ALMACEN: item.FECHA_SALIDA_ALMACEN,
      FOTO_TICKET_MUELLE: item.FOTO_TICKET_MUELLE,
      FOTOS1_TICKET_BALANZA: item.FOTOS1_TICKET_BALANZA,
      FOTO_TICKET_ALMACEN: item.FOTO_TICKET_ALMACEN,
      GUIA: item.GUIA,
      PRECINTO: item.PRECINTO,
      PERMISO: item.PERMISO,
      BODEGA: bodegaEncontrado ? bodegaEncontrado.BODEGA : "Bodega no encontrada",
      DESTINO: almacenEncontrado ? almacenEncontrado.ALMACEN : "Almacén no encontrado",
      JORNADA: jornadaItem ? jornadaItem.JORNADA : item.JORNADA
    };
    
  }).filter(element => element.ID_PRODUCTO !== undefined);
  
},

        ProductoUnico() {
      let producto = [  
      ...new Set(this.listaDatos.map(productlist => productlist.ID))
      ]
      return producto
      },
      DataCompletaAlmacen() {
      return this.listaDatosData.map((item) => {
  
        return {
          
          PESO_NETO_ALMCEN: this.convertir(item.PESO_NETO_ALMCEN),
          FECHA_INGRESO_ALMACEN: item.FECHA_INGRESO_ALMACEN,
          PLACA: item.PLACA,
          ID_DIST_PRODCUTO_ALM: item.ID_DIST_PRODCUTO_ALM,
          JORNADA: item.JORNADA
          // PUERTO: item.ID_NAVES+'_'+item.CLIENTE
                };
            }).filter(function( element ) {
          return element.FECHA_INGRESO_ALMACEN !== undefined;
        }).filter(function( element ) {
          return element.FECHA_INGRESO_ALMACEN !== 0;
        })
      },
         


      mappedItems() {
  if (this.listaDatos && this.listaDatosProducto && this.listaConsignave && this.listaClientesNave) {
    return this.listaDatos.map((item) => {
      this.listaDatosProducto.forEach(product => {
        if (product.ID == item.PRODUCTO)
          item.PRODUCTO = product.PRODUCTO;
      });

      this.listaConsignave.forEach(productoxd => {
        if (productoxd.ID == item.ID_CONSIGNATARIO)
          item.CONSIGNAVE = productoxd.CONSIGNATARIO;
      });

      this.listaClientesNave.forEach(clientnave => {
        if (clientnave.ID == item.CONSIGNAVE)
          item.CONSIGNAVE = clientnave.CONSIGNATARIO;
      });

      return {
        BAGS: item.BAGS,
        BLS: item.BLS,
        CANTIDAD: this.convertir(item.CANTIDAD),
        PRODUCTO: item.PRODUCTO,
        ID: item.ID,
        Consignatario: item.CONSIGNAVE,
      };
    });
  } else {
    console.error('Al menos una de las listas es undefined. Lista de datos:', this.listaDatos, 'Lista de productos:',
     this.listaDatosProducto, 'Lista de consignatarios:', this.listaConsignave, 'Lista de clientes de nave:', this.listaClientesNave);
    return [];
  }
  },


  
      
     },
    methods: {
      async cargarTodosLosDatos() {
      try {
        await Promise.all([
          this.getListaProducto(),
          this.getListaData(),
          this.getLista(),
          this.GetListaConsginave(),
          this.GetListaClienteNave(),
          this.GetListaJornada(),
          this.getListaAlmacenes(),
          this.getListaAlmacenesDistribucion(),
          this.getListaDistribucion(),
          this.getListaNave(),
          this.GetListaParalizacion(), 
          this.GetListaSilos()

          // Añade aquí otras funciones de carga de datos según sea necesario
        ]);
        console.log("Todos los datos se han cargado con éxito");
      } catch (error) {
        console.error("Error al cargar los datos: ", error);
      } finally {
        this.isLoading = false; // Esto se ejecuta tanto si las promesas son exitosas como si hay errores
      }
    },
    
//        initBigChart(index) {
//   let chartData = {
//     datasets: [
//       {
//         label: 'Performance 1',
//         data: this.bigLineChart.allData[index].map((value, i, arr) => ({
//           x: i === arr.length - 1 ? null : i,
//           y: value,
//         })),
//         pointBackgroundColor: 'rgba(75, 192, 192, 1)',
//         pointRadius: 5,
//         fill: false,
//       },
//       {
//         label: 'Performance 2',
//         data: this.redBarChart.chartData.datasets[0].data.map((value, i, arr) => ({
//           x: i === arr.length - 1 ? null : i,
//           y: value,
//         })),
//         pointBackgroundColor: 'rgba(255, 0, 0, 1)',
//         pointRadius: 5,
//         fill: false,
//       },
//     ],
//     labels: ['May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'as'],
//   };
//   this.bigLineChart.chartData = chartData;
//   this.bigLineChart.activeIndex = index;
// },

ManifestadoBalanza(idproductophite) {
      let pnetoTotal = 0
      let res =  this.mappedItems.filter(val => {
      return val.ID == idproductophite;
      })

      res.forEach(element => {
      pnetoTotal += element.CANTIDAD
      });

      return pnetoTotal.toFixed(3);

      },


formatDate(dateString) {
      // Implementa la lógica para formatear la fecha según tus necesidades
      // Puedes usar bibliotecas como moment.js o simplemente JavaScript puro.
      // Por ejemplo:
      const date = new Date(dateString);
      return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
    },

      getInitials(text) {
          return text
            .split(' ')
            .map(word => word.charAt(0).toUpperCase())
            .join('');
        },

   actualizarAlmacen(index, nuevaPropiedad) {
    // Utiliza Vue.set para mantener la reactividad
    this.$set(this.listaDatosAlmacenDistribucion, index, nuevaPropiedad);
  },
      
     convertir(item) {
            let numero;

            if (typeof(item) === "string") {
              numero = parseFloat(item.replace(",", "."));
            } else if (typeof(item) === "number") {
              numero = item;
            }

            // Asegura que el resultado sea un string con dos decimales
            return numero.toFixed(2);
          },


            getLista(){
        axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&ID_NAVES="+this.ID_NAVE+"&columns=false&sheet=PRODUCTOS_NAVE" )
        .then(response => {this.listaDatos = response.data.rows.filter(consignatario => consignatario.ID_CONSIGNATARIO == this.ID_CONSIGNATARIO ) 
          
        })
        .catch(err=>{
          console.log(err);
            this.err = true;  
        })
        },

          getListaData(){
          axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&ID_NAVE="+this.ID_NAVE+"&columns=false&sheet=DATA_GRANEL" )
          .then(response => {this.listaDatosData = response.data.rows.filter(consignatario => consignatario.ID_CONSIGNATARIO == this.ID_CONSIGNATARIO ) 
            
          })
          .catch(err=>{
            console.log(err);
              this.err = true;  
          })
          },

          getListaAlmacenes(){
          axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&columns=false&sheet=LISTA_ALMACENES" )
          .then(response => {this.ListaAlmacenes = response.data.rows;
            
          })
          .catch(err=>{
            console.log(err);
              this.err = true;  
          })
          },
          

          getListaProducto(){
          axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&columns=false&sheet=LISTA_PRODUCTOS" )
          .then(response => {this.listaDatosProducto = response.data.rows;
            
          })
          .catch(err=>{
            console.log(err);
              this.err = true;  
          })
          },
          GetListaConsginave(){
          axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&columns=false&sheet=CONSIGNATARIO_NAVE" )
          .then(response => {this.listaConsignave = response.data.rows;
            
          })
          .catch(err=>{
            console.log(err);
              this.err = true;  
          })
          },

          GetListaClienteNave(){
          axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&columns=false&sheet=CLIENTES_GRANEL" )
          .then(response => {this.listaClientesNave = response.data.rows;
            
          })
          .catch(err=>{
            console.log(err);
              this.err = true;  
          })
          },

          
                  getListaNave() {
          axios.get("https://gsx2json.aygajustadores.com/api?id=1Tpui79bHcuKUYPu_n7hdNQSUdphCjtmHTKW1_BCHelw&ID="+this.ID_NAVE+"&columns=false&sheet=NAVES" )
            .then((response) => {
              this.listaNaves = response.data.rows.filter(nave => {
                return Object.keys(nave).length > 0;
              });


              this.BuquesFechas = this.BuquesFechas(); // Actualiza BuquesFechas cuando se reciban los datos
            })
            .catch((err) => {
              console.log(err);
              this.err = true;
            });
        },


         async getListaAlmacenesDistribucion(){
          axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&ID_NAVES="+this.ID_NAVE+"&columns=false&sheet=DIST_PRODUCTOS_ALM" )
          .then(response =>  {this.listaDatosAlmacenDistribucion = response.data.rows.filter(consignatario => consignatario.ID_CONSIGNATARIO == this.ID_CONSIGNATARIO )
            
          })
          .catch(err=>{
            console.log(err);
              this.err = true;  
          })
          },

          getListaDistribucion(){
          axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&ID_NAVES="+this.ID_NAVE+"&columns=false&sheet=DIST_PRODUCTOS" )
          .then(response =>  {this.listaDatosDistribucion = response.data.rows.filter(consignatario => consignatario.ID_CONSIGNATARIO == this.ID_CONSIGNATARIO )
            
          })
          .catch(err=>{
            console.log(err);
              this.err = true;  
          })
          },


          GetListaJornada() {
        axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&ID_NAVES="+this.ID_NAVE+"&columns=false&sheet=JORNADAS")
        .then(response => {
        // Filtra los elementos con propiedades específicas que no están vacías
        this.listaJornada = response.data.rows.filter(item => {
        // Ajusta las propiedades según tus necesidades
        return item.ID_NAVES !== undefined && item.ID_NAVES.trim() !== "";
        });
        })
        .catch(err => {
        console.log(err);
        this.err = true;
        });
},

          GetListaParalizacion() {
            axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&ID_NAVE=" + this.ID_NAVE + "&columns=false&sheet=PARALIZACION")
              .then(response => {
                // Filtra los objetos no vacíos y con ID_CONSIGNATARIO igual a id_consignatario
                this.listaParalizacion = response.data.rows.filter(item => {
                  return Object.keys(item).length > 0 && item.ID_CONSIGNATARIO === this.ID_CONSIGNATARIO;
                });
              })
              .catch(err => {
                console.log(err);
                this.err = true;
              })
          },

          GetListaSilos() {
            axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&ID_NAVE=" + this.ID_NAVE + "&columns=false&sheet=DATA_SILOS")
              .then(response => {
                // Filtra los objetos no vacíos y con ID_CONSIGNATARIO igual a id_consignatario
                this.listaSilos = response.data.rows.filter(item => {
                  return Object.keys(item).length > 0 && item.ID_CONSIGNATARIO === this.ID_CONSIGNATARIO;
                });
              })
              .catch(err => {
                console.log(err);
                this.err = true;
              })
          },



    },
    mounted() {
      // this.initBigChart(0);

    }
  };
</script>
<style>
.el-table .cell{
  padding-left: 0px  !important;
  padding-right: 0px  !important;
}

.el-table .cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

</style>

